import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IConfig } from '../@absract/@interface/IConfig.interface';
import { ScreenDetectorDirective } from '../directive/screenDetector.directive';
import { IfScreenLessThenDirective } from '../directive/ifScreenLessThen.directive';
import { IfScreenMoreThenDirective } from '../directive/ifScreenMoreThen.directive';
import { IfScreenTypeDirective } from '../directive/ifScreenType.directive';
import { ScreenDetectorService } from '../service/screen-detector.service';
import {IfScreenTypeNotDirective} from "../directive/ifScreenTypeNot.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [
    IfScreenTypeDirective,
    IfScreenTypeNotDirective,
    IfScreenMoreThenDirective,
    IfScreenLessThenDirective,
    ScreenDetectorDirective
  ],
  exports: [
    IfScreenTypeDirective,
    IfScreenTypeNotDirective,
    IfScreenMoreThenDirective,
    IfScreenLessThenDirective,
    ScreenDetectorDirective
  ]
})
export class MzScreenDetectorModule {
  public static forRoot(
    config: IConfig,
    debounceTime: number = 100,
    selectors: string[]
  ): ModuleWithProviders {
    return {
      ngModule: MzScreenDetectorModule,
      providers: [
        ScreenDetectorService,
        {
          provide: 'ScreenDetectorConfig',
          useValue: {
            config: config,
            debounceTime: debounceTime,
            selectors: selectors
          }
        }
      ]
    };
  }
}

export { IConfig } from '../@absract/@interface/IConfig.interface';
export { ScreenDetectorDirective } from '../directive/screenDetector.directive';
export { IfScreenLessThenDirective } from '../directive/ifScreenLessThen.directive';
export { IfScreenMoreThenDirective } from '../directive/ifScreenMoreThen.directive';
export { IfScreenTypeDirective } from '../directive/ifScreenType.directive';
export {IfScreenTypeNotDirective} from "../directive/ifScreenTypeNot.directive";
export { ScreenDetectorService } from '../service/screen-detector.service';
